import Vue from 'vue'
import Router from 'vue-router'
import index_page from '@/view/index_page'
import FL_page from '@/view/FL_page'
import detail from '@/view/detail'
import bookdetail from '@/view/bookdetail'
import callus from '@/view/call_us'
import search from '@/view/search'
Vue.use(Router)

const router=new Router({
  routes: [
	{
	path: '/',
	redirect:'/index_page'	 
	},
	{
	path: '/index_page',
	name: 'index_page',
	component: index_page,
	meta:{
		keepAlive:true,
		index:0
	}
	},
	{
	path: '/FL_page',
	name: 'FL_page',
	component: FL_page,
	meta:{
		keepAlive:true,
		index:0
	}
	},
	{
	path: '/detail',
	name: 'detail',
	component: detail,
	meta:{
		keepAlive:true,
		index:0
	}
	},
	{
	path: '/bookdetail',
	name: 'bookdetail',
	component: bookdetail,
	meta:{
		keepAlive:true,
		index:0
	}
	},
	{
	path: '/callus',
	name: 'callus',
	component: callus,
	meta:{
		keepAlive:true,
		index:0
	}
	},
	{
	path: '/search',
	name: 'search',
	component: search,
	meta:{
		keepAlive:true,
		index:0
	}
	}
	
  ]
})
// 全局路由守卫
router.beforeEach((to, from, next) => {

  next();
 
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js